import * as React from 'react';
import App from './App';
import Growls from './Growl';
import './../_scss/main.scss';
const Root = () => {
   return <React.Fragment>
         <App />
         <Growls />
         </React.Fragment>;
};

export default Root;
